import React, { useState } from "react";
import PropTypes from "prop-types";
import FormAccordion from "../../../components/Form/FormAccordion";
import {
	FileGroup,
	InputField,
	SelectField,
	SelectFieldStatus,
	TextAreaField,
	// DateTimeInputField,
} from "../../../components/Form/FormComponents";
import ActionSideBar from "../partials/ActionSideBar";
import { StyledForm } from "../../../components/Form/FormComponents.styled";
import { LeaseeInformation, LeasorInformation } from "../partials/FormFieldsLease";
import { ApprenticeInformation, InvestorInformation } from "../partials/FormFieldsAF";
import { getFormattedDate } from "../../../utils/DateUtils";
import { getNairaFormat, getUserName } from "../../../utils/Utils";
import { formatDeliveryType } from "../utils";

// eslint-disable-next-line no-unused-vars
const DeployedForm = ({ requestData, setRequestData, filter }) => {
	const [formData, setFormData] = useState(requestData);
	const [action, setAction] = useState("view");
	const isEditable = action === "edit";
	const isLeasing = filter === "lease";

	console.log(formData);
	const handleInputChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleCancel = () => {
		setFormData(requestData);
		setAction("view");
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setRequestData(formData);
	};
	const updatedData = {
		lease: {
			deliveryInfo: { ...requestData?.deliveryInfo, deliveryStatus: formData?.deliveryStatus },
		},
		AF: {
			deliveryTime: formData?.deliveryTimeIP ? new Date(formData?.deliveryTimeIP) : formData?.deliveryTime,
			deliveryAgent: formData?.deliveryAgent,
			deliveryStatus: formData?.deliveryStatus,
		},
	};
	console.log(updatedData);

	return (
		<>
			<StyledForm onSubmit={handleSubmit}>
				<ActionSideBar
					requestData={formData}
					action={action}
					setAction={setAction}
					handleCancel={handleCancel}
					canEditStatus={true}
					updatedData={updatedData}
					isEditable={isEditable}
				/>

				<div className='RightSection'>
					<FormAccordion title='Request Information' open={true}>
						<div className='grid grid-cols-3 gap-3'>
							<RequestInformation
								formData={formData}
								isEditable={isEditable}
								handleInputChange={handleInputChange}
								isLeasing={isLeasing}
							/>
						</div>
					</FormAccordion>

					{isLeasing ? (
						<>
							<FormAccordion title='Product description'>
								<div className='form-group'>
									<TextAreaField
										name='product_desc'
										value={formData?.description || formData?.productId?.description}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Key features'>
								<div className='form-group'>
									<TextAreaField
										name='keyFeatures'
										value={formData?.keyFeatures && formData?.keyFeatures?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Product specifications'>
								<div className='form-group'>
									<TextAreaField
										name='specifications'
										value={formData?.specifications && formData?.specifications?.replace(/;/g, "<br/>")}
									/>
								</div>
							</FormAccordion>

							<FormAccordion title='Leasor’s Information'>
								<LeasorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Leasee’s Information'>
								<LeaseeInformation formData={formData} />
							</FormAccordion>
						</>
					) : (
						<>
							<FormAccordion title='Proof of purchase'>
								<div className='form-group'>
									<FileGroup value={formData?.proofOfPurchaseFile?.url} />
								</div>
							</FormAccordion>

							<FormAccordion title='Investor’s Information'>
								<InvestorInformation formData={formData} />
							</FormAccordion>

							<FormAccordion title='Apprentice’s Information'>
								<ApprenticeInformation formData={formData} />
							</FormAccordion>
						</>
					)}
				</div>
			</StyledForm>
		</>
	);
};

/* eslint-disable react/prop-types */
const RequestInformation = ({ formData, isEditable, handleInputChange, isLeasing }) => {
	return (
		<>
			<div className='form-group'>
				<label>DATE / TIME</label>
				<InputField name='createdAt' value={getFormattedDate(formData?.createdAt)} />
			</div>

			<div className='form-group'>
				<label>TRN ID</label>
				<InputField name='trnId' value={"TRN-" + formData?.objectId} />
			</div>

			{isLeasing ? (
				<div className='form-group'>
					<label>ASSET</label>
					<InputField name='productName' value={formData?.productName} />
				</div>
			) : (
				<div className='form-group'>
					<label>BUSINESS INTEREST</label>
					<InputField name='businessType' value={formData?.businessType} />
				</div>
			)}

			<div className='form-group'>
				<label>RECIPIENT</label>
				<InputField name='leasor' value={getUserName(formData)} />
			</div>

			<div className='form-group'>
				<label>DATE OF AGREEMENT</label>
				<InputField
					name='color'
					value={new Date(
						`${formData?.leaseAgreement?.date || formData?.financeAgreement?.date}`
					).toDateString()}
				/>
			</div>

			<div className='form-group'>
				<label>LOGISTIC STATUS</label>
				<SelectField name='logistic status' value={formData?.logisticStatus || "N/A"} />
			</div>

			<div className='form-group'>
				<label>DELIVERY METHOD</label>
				<SelectField
					name='deliveryType'
					value={formatDeliveryType(formData?.deliveryType || "door delivery")}
				/>
			</div>

			{isLeasing && formData?.deliveryType === "door-delivery" ? (
				<>
					<div className='form-group'>
						<label>ESTIMATED DELIVERY TIME</label>
						<InputField
							name='deliveryDate'
							value={new Date(`${formData?.deliveryInfo?.deliveryDate}T00:00:00.000Z`).toDateString()}
						/>
					</div>

					<div className='form-group'>
						<label>DELIVERY FEE</label>
						<InputField
							isEditable={false}
							handleChange={handleInputChange}
							name='deliveryFee'
							value={getNairaFormat(formData?.deliveryInfo.deliveryFee)}
						/>
					</div>
					<div className='form-group'>
						<label>DELIVERY AGENT</label>
						<InputField
							name='deliveryAgent'
							handleChange={handleInputChange}
							isEditable={false}
							value={formData?.deliveryInfo?.deliveryAgent}
						/>
					</div>

					<div className='form-group'>
						<label>DELIVERY ADDRESS</label>
						<SelectField name='logistic status' value={formData?.deliveryAddress} />
					</div>
				</>
			) : (
				<>
					<div className='form-group'>
						<label>ESTIMATED DELIVERY TIME</label>
						<InputField
							name='deliveryDate'
							value={new Date(`${formData?.deliveryInfo?.deliveryDate}T00:00:00.000Z`).toDateString()}
						/>
					</div>

					<div className='form-group'>
						<label>DELIVERY FEE</label>
						<InputField
							isEditable={false}
							handleChange={handleInputChange}
							name='deliveryFee'
							value={getNairaFormat(formData?.deliveryInfo.deliveryFee)}
						/>
					</div>
					<div className='form-group'>
						<label>DELIVERY AGENT</label>
						<InputField
							name='deliveryAgent'
							handleChange={handleInputChange}
							isEditable={false}
							value={formData?.deliveryInfo?.deliveryAgent}
						/>
					</div>

					<div className='form-group'>
						<label>DELIVERY ADDRESS</label>
						<SelectField
							name='logistic status'
							value={formData?.deliveryAddress || formData?.user?.homeAddress}
						/>
					</div>
				</>
			)}

			<div className='form-group'>
				<label>STATUS</label>
				<SelectFieldStatus
					name='deliveryStatus'
					value={formData?.deliveryStatus}
					handleChange={handleInputChange}
					isEditable={isEditable}
					type={formData?.deliveryStatus?.toLowerCase()}
					options={["Pending", "delivered", "not delivered"]}
				/>
			</div>
		</>
	);
};

// Props Validation
DeployedForm.propTypes = {
	requestData: PropTypes.object,
	setRequestData: PropTypes.func,
	filter: PropTypes.string,
};

export default DeployedForm;
